// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__table--Orc6V {
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__thead--sZuSV {
  display: grid;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__tbody--uv_cB {
  display: grid;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aPositions/Bom2aPosSelectTable/Bom2aPosSelectTable.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACA;EACE,aAAA;AACF;AACA;EACE,aAAA;AACF","sourcesContent":[".table {\n  display: flex;\n  flex-direction: column;\n}\n.thead {\n  display: grid;\n}\n.tbody {\n  display: grid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__table--Orc6V`,
	"thead": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__thead--sZuSV`,
	"tbody": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPosSelectTable-Bom2aPosSelectTable-module__tbody--uv_cB`
};
export default ___CSS_LOADER_EXPORT___;
